module.exports = __webpack_public_path__ + "static/img/wxcode.11d7ddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personal/wxcode.png
// module id = YPeG
// module chunks = 40